import { style_names } from "../operations/styles";
import { fontFamily } from "../toolbar/structure";
import { defaultStyles} from "../toolbar/defaults";
import { find } from "../helpers/array";
import { getDelimiters } from "../operations/formats";

export function init(view){
	view._parseExcel = function(obj, driver){
		const options = obj.options || {};
		options.math = view.config.math;

		const full = { sheets:[]};
		const fmt = {count: view._formats.formatsCount, cache:{}};
		for(let i  = 0; i< obj.names.length; i++){
			options.name = obj.names[i];
			full.sheets.push({
				name:options.name,
				state:obj.states[i],
				content:_excel_to_data(view, driver.getSheet(obj, options), obj.ranges, i, fmt)
			});
		}
		return full;
	};
	view._parseCsv = function(obj, driver){
		obj = driver.getRecords(obj);

		const dataObj = webix.copy(obj);
		const data = [];

		for(let i = 0; i < dataObj.length; i++){
			let item = dataObj[i].split(driver.cell);
			for(let c  = 0; c<item.length; c++){
				const row = i+1, column = c+1;
				data.push([row, column, item[c]]);
			}
		}
		return { data };
	};
}

function _excel_to_data(view, obj, ranges, index, fmt){
	const dataObj = webix.copy(obj.data);
	const data =  [];

	const typesMap = new Map();
	if (obj.types)
		for (const type of obj.types)
			typesMap.set(`${type[0]},${type[1]}`, type[2]);

	for (let i = 0; i < dataObj.length; i++){
		for(let c = 0; c<dataObj[0].length; c++){
			const row = i+1, column = c+1;
			let val = dataObj[i][c];
			if(obj.links.length){
				let link = find(obj.links, link => link[0] == i && link[1] == c);
				if(link){
					link = typeof link[2] == "string" && link[2][0] == "=" ? link[2].slice(1) : `"${link[2]}"`;
					val = typeof val == "string" && val[0] == "=" ? val.slice(1) : `"${val}"`;
					val = `=HYPERLINK(${link}, ${val})`;
				}
			}
			data.push([row, column, val, "", typesMap.get(`${i},${c}`)]);
		}
	}
	obj.data = data;

	//merged cells
	if(obj.spans){
		for(let i = 0; i<obj.spans.length; i++){
			obj.spans[i][0]++;
			obj.spans[i][1]++;
		}
	}

	//named ranges
	if(ranges){
		for(let r = 0; r < ranges.length; r++){
			const sheetIndex = ranges[r].Sheet;
			const book = webix.isUndefined(sheetIndex);
			if(book || sheetIndex === index){
				obj.ranges = obj.ranges || [];
				obj.ranges.push([ranges[r].Name.toUpperCase(), ranges[r].Ref.substring(ranges[r].Ref.indexOf("!")+1).replace(/\$/g, ""), book]);
			}
		}
	}

	//cell styles
	if(obj.styles)
		_getStyles(view, obj, fmt);

	if(!obj.table)
		obj.table = {groups:{}};

	if(obj.rowGroups)
		obj.table.groups.row = restoreGroups(obj.rowGroups);

	if(obj.columnGroups)
		obj.table.groups.column = restoreGroups(obj.columnGroups);

	if(obj.hidden)
		_getHidden(obj);

	//column width and row height
	if(obj.sizes){
		for(let i = 0; i<obj.sizes.length; i++){
			if(obj.sizes[i][0] == "column")
				obj.sizes[i] = [0, obj.sizes[i][1]+1, obj.sizes[i][2]];
			else
				obj.sizes[i] = [obj.sizes[i][1]+1, 0, obj.sizes[i][2]];
		}
	}

	const settings = obj.sheetSettings;
	if(settings){
		obj.table.showFormulas = settings.showFormulas;
		obj.table.gridlines = settings.showGridLines;
		obj.table.headers = settings.showRowColHeaders;
		obj.table.zoom = settings.zoomScale / 100;
	}

	return obj; 
}

//ARGB conversion
function _safeColor(str){
	str = str || "000000";
	if(str.length === 8) str = str.substring(2);
	return "#"+str;
}

//only fonts that we support can be imported
function _safeFont(str){
	let safe = defaultStyles["font-family"];
	for(let i = 0; i<fontFamily.length; i++){
		if(fontFamily[i].value == str) { safe = fontFamily[i].id; break; }
	}
	return safe;
}

function _getHidden(obj){
	obj.table.hidden = {
		row:[],
		column:[]
	};

	for(let i = 0; i < obj.hidden.length; i++){
		const item = obj.hidden[i];
		if(item[0] == "column")
			obj.table.hidden.column.push(item[1]+1);
		else
			obj.table.hidden.row.push(item[1]+1);
	}
}

function _getBorderStyles(pos, stl){
	pos = pos.replace("border-", "");
	if(stl.border && stl.border[pos]){
		const border = stl.border[pos];
		if(border.color){
			const color = _safeColor(border.color.rgb) || "";
			const type = border.style || "";
			return `${color},${type}`;
		}
	}
	return "";
}

function _getStyles(view, obj, fmt){
	let stylescount = 1;
	const styleshash = {}, styles = [], formats = [];

	for(let i = 0; i<obj.styles.length; i++){
		let str = [], stl = obj.styles[i][2], css;

		for(let s  = 0; s<style_names.length; s++){
			switch (style_names[s]){
				case "color": 
					str[s] = stl.font && stl.font.color ? (_safeColor(stl.font.color.rgb) || "") : "";
					break;
				case "background":
					str[s] = stl.fill && stl.fill.fgColor ? (_safeColor(stl.fill.fgColor.rgb) || "") : "";
					break;
				case "text-align":
					str[s] = (stl.alignment ? stl.alignment.horizontal : "") || defaultStyles["text-align"];
					break;
				case "font-family":
					str[s] = stl.font && stl.font.name ? _safeFont(stl.font.name) : "";
					break;
				case "font-size":
					str[s] = stl.font && stl.font.sz ? ((stl.font.sz/0.75)+"px" || "") : ""; //pt to px conversion
					break;
				case "font-style":
					str[s] = stl.font && stl.font.italic ? "italic" : "";
					break;
				case "underline":
					str[s] = stl.font && stl.font.underline ? "underline" : "";
					break;
				case "strike":
					str[s] = stl.font && stl.font.strike ? "strike" : "";
					break;
				case "font-weight":
					str[s] = stl.font && stl.font.bold ? "bold" : "";
					break;
				case "vertical-align":{
					const va = stl.alignment ? (stl.alignment.vertical || "") : "";
					str[s] = (va == "center" ? "middle" : va) || defaultStyles["vertical-align"];
					break;
				}
				case "wrap":
					str[s] = stl.alignment && stl.alignment.wrapText ? "wrap" : "nowrap";
					break;
				case "borders":
					str[s] = "";
					break;
				case "format":{
					let format = stl.numFmt;
					let name = "";
					if(format && format != "General"){
						const delimiters = getDelimiters(format.indexOf("[$") != -1 ? "price" : "int");
						format = format.replaceAll("\\", "").replace(/("[^"]*"|\[[^\]]*\]|\.|,)/g, function(match) {
							if (match === ".") return delimiters.decimalSign;
							if (match === ",") return delimiters.groupSign;
							return match;
						});

						if(view._formats.formatCache[format])
							name = view._formats.formatCache[format];
						else if(fmt.cache[format])
							name = fmt.cache[format];
						else
							name = fmt.cache[format] = "fmt"+(fmt.count++);

						if(!find(formats, arr => arr[0] == name))
							formats.push([name, format]);
					}
					str[s] = name;
					break;
				}
				case "border-right":
				case "border-bottom":
				case "border-left":
				case "border-top":
					str[s] = _getBorderStyles(style_names[s], stl);
					break;
				case "indent":
					str[s] = stl.alignment && stl.alignment.indent ? stl.alignment.indent : "";
					break;
			}
		}
		str = str.join(";");
		css = styleshash[str] || "wss"+stylescount;

		for(let d = 0; d<obj.data.length; d++){
			if(obj.data[d][0] === obj.styles[i][0]+1 && obj.data[d][1] === obj.styles[i][1]+1){
				obj.data[d][3] = css;
				break;
			}
		}
		if(!styleshash[str]){
			styles.push([css, str]);
			styleshash[str] = css;
			stylescount++;
		}
	}

	obj.formats = formats;
	obj.styles = styles;
}

function restoreGroups(groupsArray) {
	const result = [];
	const activeGroups = [];

	for (let i = 0; i < groupsArray.length; i++) {
		const level = groupsArray[i];
		if (level === null || level === undefined) continue;

		const currentDepth = level - 1;

		while (activeGroups.length > 0 && activeGroups[activeGroups.length - 1].level > currentDepth) {
			const group = activeGroups.pop();
			group.end = i;
			result.push(group);
		}

		if (activeGroups.length <= currentDepth) {
			while (activeGroups.length <= currentDepth) {
				const newLevel = activeGroups.length;
				activeGroups.push({
					start: i + 1,
					end: null,
					level: newLevel,
					open: true
				});
			}
		}
	}

	while (activeGroups.length > 0) {
		const group = activeGroups.pop();
		group.end = groupsArray.length;
		result.push(group);
	}

	return result;
}